import { ErrorHandler, Injectable } from '@angular/core';
import { formatErrorForInstana } from '../utils/error-serializer.util';

@Injectable()
export class InstanaErrorHandler implements ErrorHandler {
  public handleError(error: any): void {
    if (ineum === undefined || typeof ineum !== 'function') {
      return;
    }

    this.reportError(error);
  }

  private reportError(error: any): void {
    const formattedError = formatErrorForInstana(error);
    ineum('reportError', `[GLOBAL-ERROR] ${formattedError}`);
    console.warn('[InstanaErrorHandler] Reported Caught Error to Instana:', error);
  }
}

